((window, document) => {

    // defer to body.onload as bootstrap wont be loaded yet
    window.addEventListener("DOMContentLoaded", () => {
        const bootstrap = window.bootstrap;
        if (bootstrap) {
            function getTargetHtml(target: string) {
                const content = document.querySelector(target)!;
                content.remove();
                content.classList.remove('d-none');
                return content.outerHTML;
            }

            Array.from<HTMLElement>(document.querySelectorAll('[data-bs-toggle="dropdown"]')).map(el => {
                new bootstrap.Dropdown(el, {
                    autoClose: 'outside'
                })
            });

            Array.from<HTMLElement>(document.querySelectorAll('[data-bs-toggle="popover"]')).map(el => {
                new bootstrap.Popover(el, {
                    content: el.dataset.content ?? getTargetHtml(el.dataset.bsTarget!),
                    html: true,
                    sanitize: false
                })
            });
        }
    });
})(window, document);